<p-sidebar [(visible)]="isVisible" position="right" styleClass="rhd-sidebar" [blockScroll]="true" (onHide)="onHide()">
  <ng-template pTemplate="header">
    <span class="rhd-title">What's New In Remmi</span>
  </ng-template>

  <div class="rhd-filters">
    <div class="position-relative">
      <input type="text" class="_input-icon w-100" placeholder="Search releases..." [(ngModel)]="search" (ngModelChange)="onSearchChange()" />
      <i class="pi pi-search _search-icon"></i>
    </div>
    <ng-select
      [items]="moduleOptions"
      bindLabel="label"
      bindValue="value"
      [multiple]="true"
      [closeOnSelect]="false"
      placeholder="All Modules"
      [(ngModel)]="modules"
      (ngModelChange)="onModuleChange()"></ng-select>
  </div>

  <div class="rhd-list">
    <button type="button" class="rhd-row" *ngFor="let item of items; trackBy: trackById" (click)="open(item)">
      <div class="rhd-row__top">
        <app-release-pill [value]="item.type" [label]="item.type_label"></app-release-pill>
        <span class="rhd-row__meta">{{ item.module_label || item.module }} · {{ item.release_date | date: 'dd/MM/yyyy' }}</span>
        <span class="rhd-row__dot" *ngIf="isNew(item)" title="New"></span>
      </div>
      <p class="rhd-row__title">{{ item.title }}</p>
      <p class="rhd-row__summary" *ngIf="item.summary">{{ item.summary }}</p>
    </button>

    <div class="rhd-empty" *ngIf="!isLoading && !items.length">
      <i class="pi pi-megaphone"></i>
      <p class="rhd-empty__title">No releases found</p>
      <p class="rhd-empty__hint">Only published releases for your role and permissions appear here.</p>
    </div>
    <div class="rhd-loading" *ngIf="isLoading"><i class="pi pi-spin pi-spinner"></i></div>
    <button type="button" class="_outline-btn rhd-more" *ngIf="hasMore && !isLoading" (click)="loadMore()">Load More</button>
  </div>
</p-sidebar>
